<template>
<footer class="footer text-center">
  <p>Contact me</p>
  <ul>
    <li class="footer-links"><a class="footer-link fab fa-linkedin" href="https://www.linkedin.com/in/elena-hernández"></a> | </li>
    <li class="footer-links"><a class="footer-link fab fa-github" href="https://github.com/ElenaHrndz?tab=repositories/"></a> | </li>
    <li class="footer-links"><a class="footer-link fab fa-instagram" href="https://www.instagram.com/maleny_art/?hl=es-la"></a> | </li>
    <li class="footer-links"><a class="footer-link far fa-envelope" href="mailto:hrndzelena@gmail.com"></a></li>
  </ul>
  <p class="footer">© 2019 Elena Hernández. All rights reserved.</p>
</footer>
</template>
<script>
export default {
  name: 'foot',
  data () {
    return {
      msg: 'This is footer!!!'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Foot.vue